import zipImg from '../assets/zip.png'
import musicImg from '../assets/music.png'
import docImg from '../assets/doc.png'
import videoImg from '../assets/video.png'

// 文件相关的常量

export const allFileType = [
  {
    name: '图片',
    key: 'image',
    suffix: ['.gif', '.png', '.jpg', '.jpeg', '.bmp', '.JPG', '.PNG'],
    extension: [
      'gif',
      'png',
      'jpg',
      'jpeg',
      'bmp',
      'JPG',
      'PNG',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/bmp',
    ],
  },
  {
    name: '视频',
    key: 'video',
    suffix: [
      '.mp4',
      '.m3u8',
      '.flv',
      '.f4v',
      '.webm',
      '.m4v',
      '.mov',
      '.3gp',
      '.avi',
      '.wmv',
    ],
    extension: [
      'mp4',
      'm3u8',
      'flv',
      'f4v',
      'webm',
      'm4v',
      'mov',
      '3gp',
      'avi',
      'wmv',
    ],
  },
  {
    name: '音频',
    key: 'audio',
    suffix: ['.mp3', '.wma', '.wav', '.amr', '.m4a'],
    extension: ['mp3', 'wma', 'wav', 'amr', 'm4a'],
  },
  {
    name: '文档',
    key: 'doc',
    suffix: ['.doc', '.docx', '.pdf', '.ppt', '.pptx', '.txt'],
    extension: ['doc', 'docx', 'ppt', 'pptx'],
  },
  {
    name: 'excl',
    key: 'xls',
    suffix: ['.xls', '.xlsx'],
    extension: ['xls', 'xlsx'],
  },
  {
    name: 'txt文档',
    key: 'txt',
    suffix: ['.txt'],
    extension: ['txt'],
  },
  {
    name: 'pdf文档',
    key: 'pdf',
    suffix: ['.pdf'],
    extension: ['pdf'],
  },
  {
    name: '压缩文件',
    key: 'zip',
    suffix: ['.rar', '.zip', '.gzip'],
    extension: ['rar', 'zip', 'gzip'],
  },
]
// 用于显示文件 缩略图
export const fileTypeImg = {
  gif: docImg,
  png: docImg,
  jpg: docImg,
  jpeg: docImg,
  bmp: docImg,
  mp4: videoImg,
  m3u8: musicImg,
  flv: videoImg,
  f4v: videoImg,
  webm: videoImg,
  mov: videoImg,
  '3gp': musicImg,
  avi: musicImg,
  wmv: musicImg,
  mp3: musicImg,
  wma: musicImg,
  wav: musicImg,
  amr: musicImg,
  m4a: musicImg,
  doc: docImg,
  docx: docImg,
  pdf: docImg,
  xls: docImg,
  xlsx: docImg,
  ppt: docImg,
  pptx: docImg,
  txt: docImg,
  rar: zipImg,
  zip: zipImg,
  gzip: zipImg,
}
// 图、音、视频格式
export const imgAudioVideo = [
  '.gif',
  '.png',
  '.jpg',
  '.jpeg',
  '.bmp',
  '.mp4',
  '.m3u8',
  '.flv',
  '.f4v',
  '.webm',
  '.m4v',
  '.mov',
  '.3gp',
  '.avi',
  '.wmv',
  '.mp3',
  '.wma',
  '.wav',
  '.amr',
  '.m4a',
]
